exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basic[data-v-3ddb5ce8]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
